import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/platform/api";
import { postAuthPath } from "@/platform/pendingInvite";
import { useAuth } from "@/platform/AuthContext";
import { FullScreenLoader } from "@/platform/components/primitives";

// Handles the return leg of Emergent-managed Google Auth. The user lands at
// {origin}/app#session_id=xxx; AppRouter detects the hash and renders this
// synchronously. We exchange the session_id server-side (sets the cookie),
// then route to the app (or /workspace if they have none yet).
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { applyAuth } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    // Clean the fragment out of the URL immediately
    try {
      window.history.replaceState({}, "", window.location.pathname + window.location.search);
    } catch (_e) {
      /* ignore */
    }

    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }
    (async () => {
      try {
        const payload = await api.post("/api/auth/google/session", { session_id: sessionId });
        applyAuth(payload);
        navigate(postAuthPath(payload), { replace: true });
      } catch (_e) {
        setError("We couldn't complete Google sign-in. Please try again.");
        setTimeout(() => navigate("/login", { replace: true }), 1800);
      }
    })();
  }, [navigate, applyAuth]);

  if (error) {
    return (
      <div className="min-h-screen grid place-items-center bg-[#151A24] text-slate-700 px-6 text-center">
        {error}
      </div>
    );
  }
  return <FullScreenLoader label="Signing you in" />;
}
